import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ApplicationState, AvailabilitySelector } from '../reducers';
import { AvailabilityActions } from './actions';
import { BaseActionService } from './base.action.service';
import { Product } from 'src/objects/product';
import { Destination } from 'src/objects/destination';
import { DateOfStay } from 'src/objects/date-of-stay';
import { Availability } from 'src/objects/availability';
import { Order } from 'src/objects/order';

interface IAvailabilityActionService {
  loadAvailabilities(payload: {
    product: Product;
    destination: Destination;
    dateOfStay: DateOfStay;
  }): void;

  getAvailabilities(): Observable<Availability[] | null>;
  getAvailabilitiesLoading(): Observable<boolean>;
  getAvailabilitiesError(): Observable<Error | null>;

  setSelectedAvailabilities(args: {
    product: Product;
    destination: Destination;
    dateOfStay: DateOfStay;
    order: Order;
    availabilities: Availability[];
  }): void;
  getSelectedAvailabilities(): Observable<Availability[] | null>;
}

@Injectable({
  providedIn: 'root'
})
export class AvailabilityActionService
  extends BaseActionService<ApplicationState>
  implements IAvailabilityActionService {
  protected store: Store<ApplicationState>;


  constructor() {
    const store = inject<Store<ApplicationState>>(Store);

    super(store);

    this.store = store;
  }

  readonly availabilities = this.selectSignal(AvailabilitySelector.getAvailabilities);
  readonly availabilitiesLoading = this.selectSignal(AvailabilitySelector.getAvailabilitiesLoading);
  readonly availabilitiesError = this.selectSignal(AvailabilitySelector.getAvailabilitiesError);
  readonly selectedAvailabilities = this.selectSignal(AvailabilitySelector.getSelectedAvailabilities);

  loadAvailabilities(payload: {
    product: Product;
    destination: Destination;
    dateOfStay: DateOfStay;
  }) {
    super.load(AvailabilityActions.loadAvailabilities(payload));
  }

  getAvailabilities(): Observable<Availability[] | null> {
    return super.get(AvailabilitySelector.getAvailabilities);
  }

  getAvailabilitiesLoading(): Observable<boolean> {
    return super.get(AvailabilitySelector.getAvailabilitiesLoading);
  }

  getAvailabilitiesError(): Observable<Error | null> {
    return super.get(AvailabilitySelector.getAvailabilitiesError);
  }

  setSelectedAvailabilities(args: {
    product: Product;
    destination: Destination;
    dateOfStay: DateOfStay;
    order: Order;
    availabilities: Availability[];
  }) {
    super.load(AvailabilityActions.setSelectedAvailabilities(args));
  }

  getSelectedAvailabilities(): Observable<Availability[] | null> {
    return super.get(AvailabilitySelector.getSelectedAvailabilities);
  }
}
